<script setup>
import Details from '@/components/InsuranceProgram/Details.vue';
import Advantages from '@/components/InsuranceProgram/Advantages.vue';
defineProps({
  details: {
    type: Array,
    default: () => [],
  },
  advantages: {
    type: Array,
    default: () => [],
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
const activeTab = ref('details');
watch(activeTab, async () => {
  await nextTick();
  window.dispatchEvent(new Event('resize'));
});
const tabListElement = useTemplateRef('tabList');

const onTabListResize = () => {
  tabListElement.value?.updateInkBar();
};
onMounted(() => {
  window.addEventListener('resize', onTabListResize, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onTabListResize);
});
</script>

<template>
  <div>
    <Tabs
      v-if="
        details && details.length > 0 && advantages && advantages.length > 0
      "
      v-model:value="activeTab"
      :scrollable="true"
      class="insurance-program__info-tabs"
    >
      <TabList
        ref="tabList"
        :class="`insurance-program__info-tabs-headers tabs-bg-${backgroundColor}`"
      >
        <Tab value="details" class="insurance-program__info-tabs-title">
          {{ $t('services.program_details') }}
        </Tab>
        <Tab value="advantages" class="insurance-program__info-tabs-title">
          {{ $t('services.program_advantages') }}
        </Tab>
      </TabList>
      <TabPanels class="insurance-program__info-tabs-content">
        <TabPanel value="details">
          <Details v-if="details && details.length > 0" :details="details" />
        </TabPanel>
        <TabPanel value="advantages">
          <Advantages
            v-if="advantages && advantages.length > 0"
            :advantages="advantages"
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
    <template v-else>
      <Details v-if="details && details.length > 0" :details="details" />
      <Advantages
        v-if="advantages && advantages.length > 0"
        :advantages="advantages"
      />
    </template>
  </div>
</template>
<style scoped lang="scss">
.insurance-program__info-tabs {
  display: flex;
  flex-direction: column;
  gap: 32px;
  @include media-breakpoint-up(sm) {
    gap: 48px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 48);
  }
  &-headers {
    display: flex;
    justify-content: center;
    position: relative;
    &:deep(.p-tablist-tab-list) {
      gap: 8px;
      @include media-breakpoint-up(md) {
        justify-content: center;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(gap, 8);
      }
    }

    &:deep(.p-tablist-active-bar) {
      display: none;
    }
  }
  &-title {
    @include link-normal;
    border: 1px solid $black;
    border-radius: 48px;
    color: $black;
    cursor: pointer;
    position: relative;
    padding: 7px 12px;
    text-align: center;
    transition: color 0.2s ease;
    white-space: unset;
    width: auto;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-width, 1);
      @include responsive-spacing(border-radius, 48);
      @include responsive-spacing(padding-top, 7);
      @include responsive-spacing(padding-right, 12);
      @include responsive-spacing(padding-left, 12);
      @include responsive-spacing(padding-bottom, 7);
    }
    &[data-p='active'] {
      background-color: $black;
      color: $white;
    }
  }
}
</style>
